import React from "react";
import { company } from "../mock";

const Hero = () => (
  <section
    id="home"
    data-testid="hero-section"
    className="relative flex items-center justify-center min-h-[353px] lg:min-h-[451px]"
  >
    <div
      className="absolute inset-0 bg-cover bg-center"
      style={{ backgroundImage: `url('${company.heroImg}')` }}
    />
    <div className="absolute inset-0 hero-overlay" />
    <div className="relative z-10 w-full max-w-[1140px] mx-auto px-5 py-14 text-center">
      <h1 className="text-white font-extralight text-[47px] md:text-[69px] leading-tight" data-testid="hero-title">
        {company.name}
      </h1>
      <h2 className="text-fire font-medium text-[19px] md:text-[23px] mt-1" data-testid="hero-tagline">
        {company.tagline}
      </h2>
      <div className="py-[11px]">
        <span className="block mx-auto w-[30%] h-[1.1px] bg-fire" />
      </div>
      <h3 className="text-white font-extralight uppercase tracking-[2.2px] text-[16px] md:text-[17px]" data-testid="hero-strap">
        {company.strap}
      </h3>
    </div>
  </section>
);

export default Hero;
